var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProiconsCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1665 6.16659H13.8332M4.90717 3.16659V1.83325M11.0738 3.16659V1.83325M11.4998 3.16659H4.49984C3.881 3.16659 3.28751 3.41242 2.84992 3.85C2.41234 4.28759 2.1665 4.88108 2.1665 5.49992V11.8333C2.1665 12.4521 2.41234 13.0456 2.84992 13.4832C3.28751 13.9208 3.881 14.1666 4.49984 14.1666H11.4998C12.1187 14.1666 12.7122 13.9208 13.1498 13.4832C13.5873 13.0456 13.8332 12.4521 13.8332 11.8333V5.49992C13.8332 4.88108 13.5873 4.28759 13.1498 3.85C12.7122 3.41242 12.1187 3.16659 11.4998 3.16659Z",
    stroke: "#1E1F24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProiconsCalendar);
export default __webpack_public_path__ + "static/media/proicons_calendar.8e6b155ed00ab74488c8ce31c559546b.svg";
export { ForwardRef as ReactComponent };